import ReactSplit from 'react-split';
import { Container } from 'reactstrap';
import { useIsMobile } from '@s20/components/common/Hide';
import { SplitHelper } from './SplitHelper';

export const Split = ({ children, ...restProps }) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <Container className="d-flex flex-column w-100">
                {children}
            </Container>
        );
    }

    return (
        <ReactSplit
            id="dispatchPane"
            sizes={[60, 40]}
            minSize={[324, 300]}
            expandToMin={false}
            snapOffset={30}
            dragInterval={1}
            direction="horizontal"
            cursor="col-resize"
            elementStyle={SplitHelper.flex.elementStyle}
            gutter={() => {
                const div = document.createElement('div');
                div.className = 'vr gutter gutter-horizontal';

                return div;
            }}
            {...restProps}
        >
            {children}
        </ReactSplit>
    );
};